import { CONTENT } from "@/content";

export default function Marquee() {
  const text = CONTENT.marquee;
  const repeated = Array.from({ length: 8 });
  return (
    <section
      className="py-16 md:py-24 overflow-hidden border-y"
      style={{ borderColor: "rgba(232,180,184,0.12)" }}
      data-testid="marquee-section"
    >
      <div className="marquee-track">
        {[0, 1].map((group) => (
          <div key={group} className="flex">
            {repeated.map((_, i) => (
              <span
                key={i}
                className="font-serif-d stroke-text text-6xl md:text-8xl italic font-light px-8"
              >
                {text} <span style={{ color: "var(--gold)" }}>&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
